module.exports = __webpack_public_path__ + "static/media/boatscene7.a0855ec9.webp";